import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiPackage, FiShoppingCart, FiBox, FiBarChart2, FiTruck, FiGrid, FiBell, FiSettings, FiChevronLeft, FiChevronRight, FiGlobe, FiFolder, FiPercent, FiBriefcase, FiUsers, FiShoppingBag, FiFileText, FiRotateCcw, FiServer, FiDownload, FiTrendingUp, FiLayers } from 'react-icons/fi';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const menuItems = [
    { icon: FiHome, label: 'Dashboard', path: '/dashboard' },
    { icon: FiGrid, label: 'Platforms', path: '/platforms' },
    { icon: FiFolder, label: 'Categories', path: '/categories' },
    { icon: FiLayers, label: 'Item Groups', path: '/item-groups' },
    { icon: FiPercent, label: 'GST Rates', path: '/gst' },
    { icon: FiFileText, label: 'GST Report', path: '/gst-report' },
    { icon: FiBriefcase, label: 'Vendors', path: '/vendors' },
    { icon: FiUsers, label: 'Customers', path: '/customers' },
    { icon: FiPackage, label: 'Products', path: '/products' },
    { icon: FiShoppingBag, label: 'Purchases', path: '/purchases' },
    { icon: FiShoppingCart, label: 'Orders', path: '/orders' },
    { icon: FiRotateCcw, label: 'Returns', path: '/returns' },
    { icon: FiBox, label: 'Inventory', path: '/inventory' },
    { icon: FiBarChart2, label: 'Reports', path: '/reports' },
    { icon: FiTrendingUp, label: 'P&L Analysis', path: '/profit-loss' },
    { icon: FiDownload, label: 'Export/Import', path: '/tools' },
    { icon: FiTruck, label: 'Shipping', path: '/shipping' },
    { icon: FiGlobe, label: 'Web Scraping', path: '/scraping' },
    { icon: FiBell, label: 'Notifications', path: '/notifications' },
    { icon: FiServer, label: 'User Roles', path: '/users' },
    { icon: FiSettings, label: 'Settings', path: '/settings' },
  ];

  return (
    <aside className={`${isOpen ? 'w-64' : 'w-20'} bg-white dark:bg-gray-800 shadow-lg transition-all duration-300 ease-in-out flex flex-col`}>
      <div className="flex items-center justify-between p-4 border-b dark:border-gray-700">
        {isOpen && <h1 className="text-xl font-bold text-gray-800 dark:text-white">eComm SaaS</h1>}
        <button onClick={() => setIsOpen(!isOpen)} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
          {isOpen ? <FiChevronLeft className="text-gray-600 dark:text-gray-300" /> : <FiChevronRight className="text-gray-600 dark:text-gray-300" />}
        </button>
      </div>
      <nav className="flex-1 overflow-y-auto py-4">
        {menuItems.map((item) => (
          <NavLink key={item.path} to={item.path} className={({ isActive }) =>
            `flex items-center px-6 py-3 text-gray-700 dark:text-gray-300 hover:bg-primary-50 dark:hover:bg-gray-700 transition-colors ${isActive ? 'bg-primary-50 dark:bg-gray-700 border-r-4 border-primary-500' : ''}`}
          >
            <item.icon className="w-5 h-5 min-w-[20px]" />
            {isOpen && <span className="ml-3">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
